import React from 'react'
import {Field, reduxForm} from 'redux-form'

import {validate} from "./validation/validate";
import {renderTextField} from './fields/TextField';
import {renderSelectField} from './fields/SelectField';
import MenuItem from 'material-ui/MenuItem';

import FileField from './fields/FileField';
import RemoteSubmitButton from './RemoteSubmitButton';

const SimpleForm = props => {
    const {
        handleSubmit,
        // pristine,
        // reset,
        submitting,
        // files
        ajaxCallInProgress,
    } = props

    console.log(submitting);
    return (
        <div className="form-container">
            <div className='errorContainer'>

            </div>
            <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div>
                    <Field
                        className="form-field"

                        name="surname"
                        type="text"
                        component={renderTextField}
                        autoComplete="surname"
                        label="Apellido"/>
                    <Field
                        className="form-field"

                        name="names"
                        type="text"
                        component={renderTextField}
                        autoComplete="names"
                        label="Nombres"/>
                    <Field
                        className="form-field"

                        name="email"
                        type="text"
                        component={renderTextField}
                        autoComplete="email"
                        label="Email"/>
                    <Field
                        className="form-field"

                        name="age"
                        type="number"
                        component={renderTextField}
                        autoComplete="age"
                        label="Edad"/>


                    <div className="field-group">
                        <Field className="form-field" name="dni_type" id="dnitype" style={{maxWidth: '180px'}}
                               component={renderSelectField}

                               label='Tipo de documento'>
                            <MenuItem value="DNI" primaryText="DNI"/>
                            <MenuItem value="CI" primaryText="CI"/>
                            <MenuItem value="LE" primaryText="LE"/>
                            <MenuItem value="LC" primaryText="LC"/>
                            <MenuItem value="otro" primaryText={'Otro'}/>
                        </Field>


                        <Field
                            className="form-field"
                            style={{maxWidth: '250px'}}
                            id="dni"
                            name="dni"
                            type="text"
                            component={renderTextField}
                            label={'Documento'}
                            autoComplete="dni"

                        />
                    </div>

                    <div className="field-group">
                        <Field
                            className="form-field"
                            id="address"
                            name="address"
                            type="text"
                            component={renderTextField}
                            label={'Dirección'}
                            autoComplete="address"

                        />
                    </div>

                    <div className="field-group">
                        <Field
                            className="form-field"
                            id="location"
                            name="location"
                            type="text"
                            component={renderTextField}
                            label={'Localidad'}
                            autoComplete="location"

                        />
                    </div>

                    <div className="field-group">
                        <Field
                            className="form-field"
                            id="cp"
                            name="cp"
                            type="text"
                            component={renderTextField}
                            label={'Código Postal'}
                            autoComplete="cp"

                        />
                    </div>


                    <div className="field-group">

                        <Field
                            className="form-field"
                            id="telephone"
                            name="telephone"
                            type="text"
                            component={renderTextField}
                            label={'Teléfono'}
                            autoComplete="telephone"

                        />

                        <Field
                            className="form-field"
                            id="prefix_celphone"
                            name="prefix_celphone"
                            type="text"
                            component={renderTextField}
                            label={'Prefijo Celular'}
                            autoComplete="prefix_celphone"

                        />

                        <Field
                            className="form-field"
                            id="celphone"
                            name="celphone"
                            type="text"
                            component={renderTextField}
                            label={'Celular'}
                            autoComplete="celphone"

                        />
                    </div>

                    <div className="field-group">
                        <Field className="form-field" name="monotributo" id="monotributo"
                               component={renderSelectField}

                               label='Monotributo'>
                            <MenuItem value="Si" primaryText="Si"/>
                            <MenuItem value="No" primaryText="No"/>

                        </Field>
                    </div>

                    <div className="field-group">
                        <Field
                            className="form-field cuit"
                            id="cuit"
                            name="cuit"
                            type="text"
                            component={renderTextField}
                            label={'CUIT'}
                            autoComplete="cuit"

                        />
                    </div>

                    <div className="field-group">
                        <Field className="form-field experience" name="experience" id="experience"
                               component={renderSelectField}

                               label='Experiencia'>
                            <MenuItem value="Si" primaryText="Si"/>
                            <MenuItem value="No" primaryText="No"/>

                        </Field>
                    </div>

                    <div className="field-group">
                        <Field className="form-field level" name="level" id="level"
                               component={renderSelectField}

                               label='Nivel Educativo'>
                            <MenuItem value="Secundario" primaryText="Secundario"/>
                            <MenuItem value="Terciario" primaryText="Terciario"/>
                            <MenuItem value="Universitario" primaryText="Universitario"/>

                        </Field>
                    </div>

                    <div className="field-group">
                        <Field className="form-field tablet_handling" name="tablet_handling" id="tablet_handling"
                               component={renderSelectField}

                               label='Manejo de Tablet'>
                            <MenuItem value="Si" primaryText="Si"/>
                            <MenuItem value="No" primaryText="No"/>

                        </Field>
                    </div>

                    <div className="field-group">
                        <Field
                            className="form-field box_holder"
                            id="box_holder"
                            name="box_holder"
                            type="text"
                            component={renderTextField}
                            label={'Titular Caja de Ahorro'}
                            autoComplete="box_holder"

                        />
                    </div>

                    <div className="field-group">
                        <Field className=" form-field position" name="position" id="position"
                               component={renderSelectField}

                               label='Posición a la que se postula'>
                            <MenuItem value="Encuestador" primaryText="Encuestador"/>
                            <MenuItem value="Supervisor" primaryText="Supervisor"/>
                            <MenuItem value="Encuestador - Supervisor" primaryText="Encuestador y Supervisor"/>

                        </Field>
                    </div>


                </div>

                <div>
                    <br/>
                    <br/>


                    <Field component={FileField} name='uploadfile' accept='application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/jpeg'/>
                </div>

                <div>
                    <RemoteSubmitButton disabled={ajaxCallInProgress !== 0}/>
                </div>
            </form>
        </div>
    )
}

export default reduxForm({
    form: 'SimpleForm',
    validate, // <--- validation function given to redux-form
})(SimpleForm)




// WEBPACK FOOTER //
// ./src/components/Form.js